import article from './article.json';
import footer from './footer.json';
import common from './common.json';
import auth from './auth.json';
import account from './account.json';
import about from './about.json';
import notFound from './not-found.json';

export default {
  footer,
  common,
  article,
  auth,
  account,
  about,
  notFound,
}
